import React, { useState, useEffect } from "react";
import useHandleNFT from "../../../../hooks/blockchain/useHandleNFT";

const KeyRewardsDetails = ({ token }) => {
  const [rewardsPerSec, setRewardsPerSec] = useState(0);
  const [rewards, setRewards] = useState(0);
  const [timerID, setTimerID] = useState(0);


  useEffect(() => {
    setRewards(+token?.reward);

    clearInterval(timerID);

    // const timer = setInterval(() => {
    //   console.log(`<timer> KeyRewardDetail `);
    //   setRewards((prev) => +prev + +rewardsPerSec);
    // }, 1000);
    // setTimerID(timer);

    return () => clearInterval(timerID);
  }, [rewardsPerSec, token?.reward]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="totalPoolReward__details--block">
      <span className="totalPoolReward__details--text">
        Treasure Key #{token?.tokenID}
      </span>
      <span className="totalPoolReward__details--value">
        {rewards ? rewards?.toFixed(5) : 0}
      </span>
    </div>
  );
};

export default KeyRewardsDetails;
